'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import { Session } from 'next-auth';
import { ReactNode } from 'react';
import { InactivityLogout } from '@/components/InactivityLogout';

interface SessionProviderProps {
  children: ReactNode;
  session: Session | null;
}

export function SessionProvider({ children, session }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider 
      session={session} 
      refetchInterval={0}
      refetchOnWindowFocus={false}
    >
      <InactivityLogout />
      {children}
    </NextAuthSessionProvider>
  );
} 